import { createSlice } from "@reduxjs/toolkit";
import { fetchLandlords } from "../thunks/userThunks";

const userSlice = createSlice({
  name: "user",
  initialState: {},
  extraReducers: (builder) => {

    builder.addCase(fetchLandlords.fulfilled, (state, action) => {

    });
  },
});

export default userSlice.reducer;
